import { mixed, string } from "yup";
import i18next from "utilities/i18n";
import { TypeCheck } from "./TypeCheck";

const parser = new DOMParser();
const isValidLookingXML = (value: string) => {
  const DOM = parser.parseFromString(value.trim(), "text/xml");
  return !DOM.getElementsByTagName("parsererror").length;
};
export type XmlStringFieldType = "xmlString";
const type: XmlStringFieldType = "xmlString";
export class xmlStringField extends string implements TypeCheck {
  constructor() {
    super();
    // @ts-ignore
    mixed.call(this, { type });
  }
  _typeCheck(value: any) {
    return isValidLookingXML(value);
  }
}
export const xmlString = () =>
  new xmlStringField().typeError(i18next.t("ERROR_INVALID_XML"));
